import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { isArray } from 'lodash';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';

import deleteLiveAccount from 'Api/live-account/deleteLiveAccount';
import { useLiveAccountState } from 'View/live-account/state';
import { useModal } from 'Store/modal';

const useDeleteLiveAccount = () => {
  const { t } = useTranslation('live-account');
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onResetModal } = useModal();
  const { updateState, filterState } = useLiveAccountState();

  return useMutation({
    mutationFn: async (id) => {
      onShowLoader({ variant: 'loader-primary' });

      return await deleteLiveAccount({ id });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['live-account', filterState] });

      onOpenToast({
        status: 'success',
        description: t('deleteSuccess'),
        duration: 5,
        alwaysShow: false,
      });

      updateState({ errorProps: {}, isOpenFormUpsert: false });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data.errors) ? error?.response?.data?.errors[0]?.message : t('deleteErrorDescription');

      updateState({
        isOpenFormUpsert: false,
        errorProps: {
          isOpen: true,
          type: 'error',
          title: t('deleteErrorTitle'),
          description: errorMessage,
          onClose: () => updateState({ errorProps: {} }),
          marginBottom: '12px',
        },
      });
    },
    onSettled: () => {
      onResetLoader();
      onResetModal();
    },
  });
};

export default useDeleteLiveAccount;